import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "@/views/LpnewView.vue";
import Thankyou from "@/views/LpnewThankyouView.vue";

const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/thankyou/",
    name: "Thankyou",
    component: Thankyou,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
